import { CrawlerResource } from './crawler.resource';
export class CrawlerService {
    constructor() {
        this.crawlerResource = new CrawlerResource();
    }
    crawlMetadata(url) {
        return this.crawlerResource.crawlMetadata(url);
    }
    crawlSource(sourceKey) {
        return this.crawlerResource.crawlSource(sourceKey);
    }
    searchSources(type, query) {
        return this.crawlerResource.searchSources(type, query);
    }
    getSource(type, name) {
        return this.crawlerResource.getSource(type, name);
    }
    async getArticles(type, name, sorting, subsource) {
        const articles = await this.crawlerResource.getArticles(type, name, sorting, subsource);
        return articles.slice(0, 2);
    }
}
export default new CrawlerService();
